import React, {createContext, useState, useEffect, useContext} from "react"

// Context'i oluşturuyoruz
const LanguageContext = createContext()

// Context provider'ı
export const LanguageProvider = ({children}) => {
  const [language, setLanguage] = useState(null)

  useEffect(() => {
    // Local storage'dan dil bilgisini alıyoruz
    const loadLanguage = () => {
      const savedLanguage = localStorage.getItem("language")
      if (savedLanguage) {
        setLanguage(savedLanguage)
      } else {
        // Eğer dil seçilmemişse varsayılan dil 'TR' olarak ayarlanır
        const defaultLanguage = "TR"
        setLanguage(defaultLanguage)
        localStorage.setItem("language", defaultLanguage)
      }
    }
    loadLanguage()
  }, [])

  // Dil değiştirme fonksiyonu
  const changeLanguage = (newLanguage) => {
    setLanguage(newLanguage)
    localStorage.setItem("language", newLanguage) // Seçilen dili kaydediyoruz
  }

  return (
    <LanguageContext.Provider value={{language, changeLanguage}}>
      {children}
    </LanguageContext.Provider>
  )
}

// Context kullanımı için custom hook
export const useLanguage = () => useContext(LanguageContext)
